<ng-content *ngIf="active" [class.active]="active"></ng-content>
